/**
 * Background work while signed in: the outbox flush loop and keeping the
 * offline pack fresh for reporters.
 */
import { useEffect } from 'react';
import { PACK_REFRESH_MS, packAge } from '../lib/sync/pack';
import { refreshPack } from './pack-refresh';
import { useMe } from './me';
import { useServices } from './services';

export function SyncRuntime() {
  const services = useServices();
  const { sync, storage } = services;
  const { can, offline, me } = useMe();
  const userId = me.user.id;
  const capture = can('survey.create');

  useEffect(() => sync.start(), [sync]);

  useEffect(() => {
    if (!capture || offline) return;
    const refresh = async () => {
      const age = await packAge(storage);
      if (age === null || age > PACK_REFRESH_MS) await refreshPack(services, userId).catch(() => {});
    };
    void refresh();
    const t = setInterval(() => void refresh(), PACK_REFRESH_MS);
    window.addEventListener('online', refresh);
    return () => {
      clearInterval(t);
      window.removeEventListener('online', refresh);
    };
  }, [capture, offline, services, storage, userId]);

  return null;
}
